import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';

@Component({
  selector: 'casinoxp-component',
  templateUrl: '../sharedTemplates/casinoxp.component.html',
})
export class CasinoXPComponent implements OnInit, AfterViewInit {
  casinoList;
  gameTypes = [];

  selectedCasinoType = 0;
  providerid;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.providerid = params['providerid'];
    });
  }

  ngOnInit() {
    this.gameTypes = [
      { id: 0, name: 'CasinoPopular', text: 'Popular' },
      { id: 1, name: 'CasinoSlot', text: 'Slot' },
      { id: 2, name: 'CasinoJackpot', text: 'Jackpot' },
      { id: 3, name: 'CasinoTable', text: 'Table' },
      { id: 4, name: 'CasinoCard', text: 'Card' },
      { id: 5, name: 'CasinoVideoPoker', text: 'Video Poker' },
    ];
  }

  ngAfterViewInit() {
    this.getCasinoXPGames();
  }

  getCasinoXPGames() {
    this._ApiService.getCasinoXPGames().then(x => {
      this.casinoList = x.filter(s => s.ProviderId == Number(this.providerid));
    });
  }

  openGame(casino) {
    if (!this._UserHelper.isSignedIn) {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
      return;
    }

    ////console.log("Open game", casino);

    if (environment.mobile) {
      this._ApiService.CasinoXPGameLaunch(casino.GameId, 1).then(x => {
        ////console.log("Game URL:", x);
        window.location.href = x + '&returnUrl=' + window.location.href;
        //this.casinoList = x;
      });
    } else {
      this._ApiService.CasinoXPGameLaunch(casino.GameId, 0).then(x => {
        ////console.log("Game URL:", x);
        window.location.href = x + '&return_url=' + window.location.href;
        //this.casinoList = x;
      });
    }
  }
}
